export function extractPlannedRouteTimes(directionData) {
  const sections = directionData?.routes?.[0]?.sections;
  if (!Array.isArray(sections) || sections.length === 0) {
    return { departureTime: null, arrivalTime: null };
  }
  const first = sections[0];
  const last = sections[sections.length - 1];
  return {
    departureTime: first?.departure?.time ?? null,
    arrivalTime: last?.arrival?.time ?? null,
  };
}

export function resolveGenerateAnchor({ userSetStart, userSetEnd }) {
  if (userSetEnd && !userSetStart) {
    return false;
  }
  return true;
}

export function parseRouteDate(value) {
  if (value == null || value === '') {
    return null;
  }
  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
}

export function syncPlannedRouteDates(
  pickerDates,
  directionData,
  { userSetStart, userSetEnd },
) {
  const { departureTime, arrivalTime } = extractPlannedRouteTimes(directionData);
  const result = {
    ...pickerDates,
    startDate: pickerDates.startDate,
    endDate: pickerDates.endDate,
  };

  if (!userSetStart && departureTime) {
    result.startDate = new Date(departureTime);
  }
  if (!userSetEnd && arrivalTime) {
    result.endDate = new Date(arrivalTime);
  }

  return result;
}

export function buildRouteInfoTimes(
  pickerDates,
  directionData,
  { userSetStart, userSetEnd },
) {
  const synced = syncPlannedRouteDates(pickerDates, directionData, {
    userSetStart,
    userSetEnd,
  });

  const time_start = parseRouteDate(synced.startDate) || new Date();
  let time_end = parseRouteDate(synced.endDate);

  if (!time_end) {
    const { arrivalTime } = extractPlannedRouteTimes(directionData);
    if (arrivalTime) {
      time_end = new Date(arrivalTime);
    }
  }

  if (
    time_end &&
    time_end.getTime() <= time_start.getTime() &&
    !userSetEnd
  ) {
    const { arrivalTime } = extractPlannedRouteTimes(directionData);
    if (arrivalTime) {
      time_end = new Date(arrivalTime);
    }
  }

  return { time_start, time_end };
}

export function computeEndDateFromDuration(startDate, durationSeconds) {
  const start = parseRouteDate(startDate);
  if (!start || !durationSeconds || durationSeconds <= 0) {
    return null;
  }
  return new Date(start.getTime() + durationSeconds * 1000);
}
